import React, { useLayoutEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import './App.css';
import PageNotFound from './pages/PageNotFound';
import { Toaster } from 'react-hot-toast';
import LayoutHome from './components/layout/LayoutHome';
import HelpCenter from './pages/HelpCenterPages/HelpCenter';
import HelpCenterLevelII from './pages/HelpCenterPages/GettingStarted';
import HelpCenterLevelIII from './pages/HelpCenterPages/GettingStartedArticles';
import Documentation from './pages/Documentation';
import PlatformOverview from './pages/PlatformOverview';
import AllIndustries from './pages/AllIndustries';
import MarketingSales from './pages/MarketingSales';
import CaseStudy from './pages/CaseStudy';
// import Login from './pages/Login';
import SecurityAndTrust from './pages/SecurityAndTrust';
import Press from './pages/Press';
import Careers from './pages/Careers';
import About from './pages/About';
import ContactUs from './pages/ContactUs';
import OurTeam from './pages/OurTeam';
import GridVenture from './pages/GridVenture';
import PricingPage from './pages/PricingPage';
import Creme21 from './pages/Creme21';
import Privacy_Policy from './pages/Privacy-Policy';
import TermsConditions from './pages/Terms-&-conditions';
import AirPurifierAdmin from './pages/AirPurifierAdmin';
import RST from './pages/Rst';
import AirPurifier from './pages/AirPurifierUser';
import BrandS26 from './pages/BrandS26';
import MUltiplayer from './pages/Multiplayer';
import Analytics from './pages/Analytics';
import SpatialAi from './pages/SpatialAi';
import UniversityAlliance from './pages/UniversityAlliance';
import { RetailEcommerce, RetailEcommerceCard } from './pages/IndustriesPages/RetailEcommerce';
import { HealthCarePharma } from './pages/IndustriesPages/HealthCarePharma';
import { EducationTraining } from './pages/IndustriesPages/EducationTraining';
import { TourismHospitality } from './pages/IndustriesPages/TourismHospitality';
import { RealStateArchitecture } from './pages/IndustriesPages/ArchitectureRealState';
import { EnergyMIning } from './pages/IndustriesPages/EnergyMIning';
import { AutomotiveTransportation } from './pages/IndustriesPages/AutomotiveTransportation';
import { DefenceAerospace } from './pages/IndustriesPages/DefenceAerospace';
import { ManuFacturingIndustrial } from './pages/IndustriesPages/ManutfacturingIndustrial';
import CampaignPage from './pages/IndustriesPages/CampaignPage';
import {OperatingSystem} from './pages/OperatingSystem';
import GettingStarted from './pages/HelpCenterPages/GettingStarted';
import GettingStartedArticles from './pages/HelpCenterPages/GettingStartedArticles';
import UsingSpatialGrid from './pages/HelpCenterPages/UsingSpatialGrid';
import UsingSpatialGridArticles from './pages/HelpCenterPages/UsingSpatialGridArticles';
import SingareniCollieries from './pages/CaseStudyPages/SingareniCollieries';
import Creme21Web from './pages/CaseStudyPages/Creme21Web';
import Americana from './pages/CaseStudyPages/Americana';
import KarnatakaTourism from './pages/CaseStudyPages/KarnatakaTourism';
import NestleS26 from './pages/CaseStudyPages/NestleS26';
import MedhaServo from './pages/CaseStudyPages/MedhaServo';
import RstTrading from './pages/CaseStudyPages/RstTrading';
import RaghvaProjects from './pages/CaseStudyPages/RaghvaProjects';
import RaghvaLifeSciences from './pages/CaseStudyPages/RaghvaLifeSciences';
import Defence from './pages/CaseStudyPages/Defence';
import CorpusCodex from './pages/CaseStudyPages/CorpusCodex';
import SpaceImmersiveExperience from './pages/CaseStudyPages/SpaceImmersiveExperience';
import GeoSpatial from './pages/CaseStudyPages/GeoSpatial';
import CarMechanicTraining from './pages/CaseStudyPages/CarMechanicTraining';
import Blogs from './pages/BlogsPages/Blogs';
import BlogDetail from './pages/BlogsPages/DynamicBlogContent';
import SpatialGridResearch from './pages/SpatialGridResearch';
import Partnership from './pages/HelpCenterPages/Partnership';
import PartnershipArticles from './pages/HelpCenterPages/PartnershipArticles';
import Licensing from './pages/HelpCenterPages/Licensing';
import LicensingArticles from './pages/HelpCenterPages/LicensingArticles';
import Alliances from './pages/HelpCenterPages/Alliances';
import AlliancesArticles from './pages/HelpCenterPages/AlliancesArticles';
import PracticesTroubleshooting from './pages/HelpCenterPages/PracticesTroubleshooting';
import PracticesTroubleshootingArticles from './pages/HelpCenterPages/PracticesTroubleshootingArticles';
import TrendingTopicDetail from './components/HelpCenterComponents/TrendingTopicDetail';


const ScrollTop = ({ children }) => {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return children;
};


const App = () => {
  return (
    <>
      <ScrollTop />
      <Toaster />
      <Routes>
        {/* <Route path="/login" element={<Login />} /> */}
        <Route element={<LayoutHome />}>
          <Route path="/" element={<Home />} />

          <Route path="/help-center" element={<HelpCenter />} />
          <Route path="/resource/blogs" element={<Blogs />} />
          <Route path="/resource/blogs/:slug" element={<BlogDetail />} />
          <Route
            path="/help-center/getting-started"
            element={<GettingStarted />}
          />
          <Route
            path="spatialgrid-research"
            element={<SpatialGridResearch />}
          />
          <Route
            path="/help-center/getting-started-articles"
            element={<GettingStartedArticles />}
          />
          <Route
            path="/help-center/using-spatialgrid"
            element={<UsingSpatialGrid />}
          />
          <Route
            path="/help-center/using-spatialgrid-articles"
            element={<UsingSpatialGridArticles />}
          />
          <Route path="/help-center/partnership" element={<Partnership />} />
          <Route
            path="/help-center/partnership-articles"
            element={<PartnershipArticles />}
          />
          <Route path="/help-center/licensing" element={<Licensing />} />
          <Route
            path="/help-center/licensing-articles"
            element={<LicensingArticles />}
          />
          <Route path="/help-center/alliances" element={<Alliances />} />
          <Route
            path="/help-center/alliances-articles"
            element={<AlliancesArticles />}
          />
          <Route
            path="/help-center/practices-troubleshooting"
            element={<PracticesTroubleshooting />}
          />
          <Route
            path="/help-center/practices-troubleshooting-articles"
            element={<PracticesTroubleshootingArticles />}
          />
          <Route
            path="/documentation/trending/:id"
            element={<Documentation />}
          />
          <Route path="/documentation" element={<Documentation />} />
          <Route path="/documentation/*" element={<Documentation />} />
          <Route
            path="/documentation/concepts/:type"
            element={<Documentation />}
          />

          <Route path="/platform-overview" element={<PlatformOverview />} />
          <Route path="/multiplayer" element={<MUltiplayer />} />
          <Route path="/real-time-analytics" element={<Analytics />} />
          <Route path="/spatial-ai" element={<SpatialAi />} />
          <Route path="/university-alliance" element={<UniversityAlliance />} />
          <Route
            path="/industries/retail-ecommerce"
            element={<RetailEcommerce />}
          />
          <Route
            path="/industries/healthcare-pharma"
            element={<HealthCarePharma />}
          />
          <Route
            path="/industries/education-training"
            element={<EducationTraining />}
          />
          <Route
            path="/industries/tourism-hospitality"
            element={<TourismHospitality />}
          />
          <Route
            path="/industries/realstate-architecture"
            element={<RealStateArchitecture />}
          />
          <Route path="/industries/energy-mining" element={<EnergyMIning />} />
          <Route
            path="/industries/automotive-transportation"
            element={<AutomotiveTransportation />}
          />
          <Route
            path="/industries/defence-aerospace"
            element={<DefenceAerospace />}
          />
          <Route
            path="/industries/manufacturing-industrial"
            element={<ManuFacturingIndustrial />}
          />
          <Route
            path="/all-industries/singareni-collieries"
            element={<SingareniCollieries />}
          />

          <Route path="/all-industries/creme21" element={<Creme21Web />} />
          <Route path="/all-industries/americana" element={<Americana />} />
          <Route
            path="/all-industries/car-mechanic-training"
            element={<CarMechanicTraining />}
          />
          <Route
            path="/all-industries/karnataka-tourism"
            element={<KarnatakaTourism />}
          />
          <Route path="/all-industries/nestles26" element={<NestleS26 />} />
          <Route
            path="/all-industries/medha-servo-drives"
            element={<MedhaServo />}
          />
          <Route path="/all-industries/rst-trading" element={<RstTrading />} />
          <Route
            path="/all-industries/raghva-projects"
            element={<RaghvaProjects />}
          />
          <Route
            path="/all-industries/raghva-life-sciences"
            element={<RaghvaLifeSciences />}
          />
          <Route
            path="/all-industries/corpus-codex"
            element={<CorpusCodex />}
          />
          <Route
            path="/all-industries/space-4dimmersive-experience"
            element={<SpaceImmersiveExperience />}
          />
          <Route path="/all-industries/geo-spatial" element={<GeoSpatial />} />

          <Route path="/all-industries/defence" element={<Defence />} />
          <Route path="/defence-aerospace" element={<DefenceAerospace />} />
          <Route path="/campaign" element={<CampaignPage />} />
          <Route path="/operating-system" element={<OperatingSystem />} />

          <Route path="/all-industries" element={<AllIndustries />} />
          <Route path="/marketing-sales" element={<MarketingSales />} />
          <Route path="/case-study" element={<CaseStudy />} />
          <Route path="/privacy-policy" element={<Privacy_Policy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
        </Route>
        {/* by Prassan */}
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/brands/s26" element={<BrandS26 />} />
        <Route path="/ourteam" element={<OurTeam />} />
        <Route path="/gridventure" element={<GridVenture />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/creme21" element={<Creme21 />} />
        <Route path="/air-purifier" element={<AirPurifierAdmin />} />
        <Route path="/rst" element={<RST />} />
        <Route path="/air-purifier-admin" element={<AirPurifierAdmin />} />

        {/* by naveen */}
        <Route path="/security-and-trust" element={<SecurityAndTrust />} />
        <Route path="/press" element={<Press />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="*" element={<PageNotFound bg={'black'} />} />
      </Routes>
    </>
  );
};

export default App;
